export enum IdentificationType {
    NationalId = "NationalId",
    Passport = "Passport",
    Other = "Other"
}